import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { company, customerData } from '../utilities/CustomerData'
import { apiURL } from '../utilities/URLs'

export default function SignUp({ setLoggedIn }) {
  const { token } = useParams()
  const navigate = useNavigate()

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState('')

  useEffect(() => {
    document.title = `${company.companyName} | SignUp`
  }, [])

  const handleSubmit = async () => {
    if(password === confirmPassword) {
      setLoading('Creating Account...')

      const customerAccountInfo = {
        password: password,
        token: token
      }

      const form = new FormData()
      form.append('customerAccountInfo', JSON.stringify(customerAccountInfo))

      const createCustomerAccountResponse = await fetch(`${apiURL}/api/createCustomerAccount`, {
        method: 'POST',
        body: form
      })
      const createCustomerAccountData = await createCustomerAccountResponse.json()

      if(createCustomerAccountData.response.error) {
        setLoading('')
        setError(createCustomerAccountData.response.error)
        setTimeout(() => {
          setError('')
        }, 2000)
      } else {
        const form = new FormData()
        form.append('loginInfo', JSON.stringify({
          companyId: company.companyId,
          email: createCustomerAccountData.response.customerEmail,
          password: password
        }))
        setLoading('Account Created Successfully! Logging in...')
        const loginWithCustomerIdResponse = await fetch(`${apiURL}/api/login`, {
          method: 'POST',
          body: form
        })
        const loginWithCustomerIdData = await loginWithCustomerIdResponse.json()

        if(loginWithCustomerIdData.response.error) {
          setLoading('')
          setError(loginWithCustomerIdData.response.error)
          setTimeout(() => {
            setError('')
          }, 2000)
        } else {
          localStorage.setItem('customerAccessToken', createCustomerAccountData.response.accessToken)
          customerData.setCustomerData(loginWithCustomerIdData.response.customerAccount)
          setLoggedIn(true)
          navigate('/dashboard')
        }
      }
    } else {
      setError('Password Do Not Match.')
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }
  
  return (
    <div className='flex flex-col items-center justify-center h-svh'>
      <img className='w-60 mb-28' src={company.companyLogoURL} alt='setcLogo' />
      <div className='w-full max-w-xs p-8 bg-white rounded-lg shadow mb-28'>
        <h1 className='mb-10 font-semibold text-lg text-center'>Please Enter A Password</h1>
        <div className='mb-4'>
          <label htmlFor='newPassword' className='block mb-2 text-sm font-bold text-gray-700 text-left'>
            Password
          </label>
          <input
            type='password'
            id='newPassword'
            placeholder='Password'
            className='w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className='mb-4'>
          <label htmlFor='confirmNewPassword' className='block mb-2 text-sm font-bold text-gray-700 text-left'>
            Confirm Password
          </label>
          <input
            type='password'
            placeholder='Confirm Password'
            id='confirmNewPassword'
            className='w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline'
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <div className='flex justify-center'>
          <button onClick={() => handleSubmit()} type='submit' className='px-4 py-2 font-bold text-white bg-primaryColor rounded hover:bg-primaryDarkColor transition duration-200'>
            Create Account
          </button>
        </div>
        {loading.length > 0 && (
          <p className='mt-5 text-center'>{loading}</p>
        )}
        {error.length > 0 && (
          <p className='text-red-600 mt-5 text-center'>{error}</p>
        )}
      </div>
    </div>
  )
}